<template>
  <section
    id="slide4"
    ref="slide4"
    class="introslide relative flex flex-col justify-start lg:justify-center min-h-screen bg-workbook-white before:hidden before:content-[''] lg:before:block lg:before:absolute lg:before:inset-y-0 lg:before:left-0 lg:before:w-5/12 lg:before:bg-workbook-orange"
  >
    <UContainer class="relative z-10 px-0! py-0">
      <UPageGrid class="m-0">
        <div
          class="headersection bg-workbook-orange lg:h-1/2 col-span-full lg:col-span-5 min-h-[50vh] lg:min-h-screen flex flex-col justify-start lg:justify-center"
        >
          <div
            class="h-full flex flex-col justify-center lg:bg-transparent w-screen  lg:w-auto max-w-none p-6 lg:px-0 relative left-1/2 -translate-x-1/2 lg:static lg:translate-x-0"
          >
            <h1 class="mb-12 lg:mb-12 md:pr-20">
              Selling should
              feel clear, visual, and fast.
            </h1>
            <div class="cta relative ">
              <h2 class="cta1 text-white text-4xl md:text-6xl font-normal mb-16">
                Like this.
              </h2>
              <div class="cta2 lg:mb-0">
                <UButton size="xl" variant="solid" color="secondary" to="/intro">
                  Try the demo workbook
                </UButton>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-span-full lg:col-span-7 min-h-[50vh] lg:min-h-screen flex items-center justify-center px-6 lg:px-0 lg:justify-start lg:pl-20 lg:pr-8 pb-8 lg:pb-0"
        >
          <WorkbookDemoMonitor />
        </div>
      </UPageGrid>
    </UContainer>
  </section>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'

import { useWindowSize } from '@vueuse/core'
import { loadGsap } from '@/utils/gsap'

const slide4 = ref<HTMLElement | null>(null)
let ctx: gsap.Context | null = null

const { width } = useWindowSize()
const isMobile = computed(() => width.value < 767)

onMounted(async () => {
  if (!process.client) return

  const { gsap } = await loadGsap()

  ctx = gsap.context(() => {
    const heading = slide4.value?.querySelector('h1')
    const cta = slide4.value?.querySelector('.cta')
    if (!heading || !cta) return

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: slide4.value,
        pin: false,
        markers: false,
        start: 'top 70%',
        end: 'top 30%',
        scrub: 2
      }
    })

    tl.fromTo(heading, { opacity: 0 }, { opacity: 1, duration: 2 })
    tl.fromTo(cta, { y: 40, opacity: 0 }, { y: 0, opacity: 1, duration: 3 }, '-=1')
  }, slide4.value || undefined)
})

onUnmounted(() => {
  ctx?.revert()
  ctx = null
})
</script>
